<template>
  <div>
    <div class="head">
      <el-button type="primary" size="small" style="width: 200px" @click="addBtn">宝山园区特殊作业活动备案新增</el-button>
    </div>
    <div class="content">
      <el-table
          :data="tbWorkPermitReportList"
          :header-cell-style="{ background: 'rgb(250,250,250)' }"
          style="width: 100%">
        <el-table-column label="企业编码" align="center" prop="companyCode"/>
        <el-table-column label="企业名称" align="center" prop="companyName"/>
        <el-table-column label="作业报备编号" align="center" prop="reportCode"/>
        <el-table-column label="作业报备时间" align="center" prop="reportTime">
          <template slot-scope="{ row }">
            <span v-if="row.reportTime">{{ row.reportTime | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" prop="remark"/>
        <el-table-column label="状态" align="center" prop="isUpload">
          <template slot-scope="{ row }">
            <Tag v-if="row.isUpload===1" color="success">已上报</Tag>
            <Tag v-if="row.isUpload===0" color="warning">未上报</Tag>
          </template>
        </el-table-column>
<!--        <el-table-column
            label="负责人"
            align="center">
          <template slot-scope="{ row }">
            {{ getEmployeeName(row.employeeId) }}
          </template>
        </el-table-column>-->
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
            <span style="margin: 0 5px;color: #e8e8e8">|</span>
            <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
      </div>
    </div>

    <!-- 添加或修改对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>

      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="作业票" prop="tbWorkPermitId">
          <el-select v-model="form.tbWorkPermitId" placeholder="请选择作业票">
            <el-option
                v-for="dict in tbWorkPermitList"
                :key="dict.id"
                :label="dict.name"
                :value="dict.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" placeholder="请输入备注"/>
        </el-form-item>
        <el-form-item label="报备时间" prop="reportTime">
          <el-date-picker v-model="form.reportTime"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="请选择报备时间">
          </el-date-picker>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import {listTbWorkPermitReport,getTbWorkPermitReport,addTbWorkPermitReport,updateTbWorkPermitReport,delTbWorkPermitReport} from '@/api/baseDate/TbWorkPermitReport';
import {getWorkPermitList} from "@/api/map"
export default {
  name: "TbWorkPermitReport",
  data() {
    return {
      tbWorkPermitReportList: [],
      tbWorkPermitList: [],
      total: 0,
      curPage: 1,
      pageSize: 10,
      open: false,
      form: {},
      rules: {},
      title: null,
    }
  },
  created() {
    this.getTbWorkPermitReportList();
    this.getTbWorkPermitList();
  },
  methods: {
    getTbWorkPermitReportList() {
      listTbWorkPermitReport({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
        this.tbWorkPermitReportList = res.body.data
        this.total = res.body.cum
      })
    },
    getTbWorkPermitList() {
      getWorkPermitList().then(res => {
        this.tbWorkPermitList = res.data.data
      })
    },
    handleType(type) {
      let list = this.riskLevelArr.filter(item => item.value === type)
      return list[0].label
    },
    pageChange(val) {
      this.curPage = val;
      this.getTbWorkPermitReportList();
    },
    addBtn() {
      this.reset()
      this.open = true
      this.title = '添加宝山园区特殊作业活动备案信息'

    },
    editBtn(row) {
      this.reset()
      const reportId = row.reportId
      getTbWorkPermitReport(reportId).then(response => {
        this.form = response.body.data
        this.open = true
        this.title = '修改宝山园区特殊作业活动备案信息'
      })
    },
    deleteBtn(row) {
      delTbWorkPermitReport(row.reportId).then(res => {
        this.$message.success('删除成功')
        this.getTbWorkPermitReportList()
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        reportId: null,
        companyCode: null,
        companyName: null,
        reportCode: null,
        reportTime: null,
        remark: null,
        deleted: null,
        createDate: null,
        createBy: null,
        updateDate: null,
        updateBy: null,
        tbWorkPermitId: null
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.reportId != null) {
            updateTbWorkPermitReport(this.form).then(response => {
              this.open = false
              this.$message.success('修改成功')
              this.getTbWorkPermitReportList()
            })
          } else {
            addTbWorkPermitReport(this.form).then(response => {
              this.open = false
              this.$message.success('新增成功')
              this.getTbWorkPermitReportList()
            })
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 280px);
}

.btn {
  cursor: pointer;
}
</style>
